/**
 * aZcentric - The framework for aZcentric.
 * @version v0.5.1-dev
 * @link http://www.azaas.com/
 * @license 
 */
(function () {
    'use strict';
    angular.module('aZcentric.components.compareTo', []).directive('compareTo', function () {
        return {
            require: 'ngModel',
            scope: {
                otherModelValue: '=compareTo'
            },
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators['compareTo'] = function (modelValue) {
                    return modelValue === scope.otherModelValue;
                };
                ngModel.$validators['compare-to'] = function (modelValue) {
                    return modelValue === scope.otherModelValue;
                };
                scope.$watch('otherModelValue', function () {
                    ngModel.$validate();
                });
            }
        };
    });
})();
